<template>
    <div class="success-page">
        <div class="success-page__inner">
            <header class="header">
                <div class="container">
                    <logo :width="105" :height="24"/>
                </div>
            </header>
            <main class="success-main">
                <router-view></router-view>
            </main>

            <section-footer :isLight="true" :isMember="true"/>

        </div>
    </div>
</template>

<script>
    import footer from '@/components/studios/StudioFooter'
    export default {
        components: {
            'section-footer': footer
        }
    }
</script>

<style lang="sass" scoped>
    .success-page
        height: 100%
        background-image: url('~@/assets/images/success/success-bg.jpg')
        +cover
        position: relative
        &:before
            content: ''
            z-index: 1
            display: block
            position: absolute
            top: 0
            left: 0
            width: 100%
            height: 100%
            background: linear-gradient(176.29deg, #0B1D4B 19.08%, rgba(11, 39, 77, 0.67) 100.88%)
            opacity: 0.8
        &__inner
            position: relative
            z-index: 2
            height: 100%
            display: flex
            flex-direction: column

        +r(599)
            background-image: none
            background-color: $color--dark
    .header
        padding-top: 55px
        +xs
            padding-top: 15px
            .logo
                max-width: 70px
                height: 16px
</style>
